// we don't need to use a variable
// or the from keyword when importing a css/styl file
// thanks the the styles loader it gets added as a
// <style> tag in the head by default but can be changed

// import 'normalize.css';
import '../styles/styles';
import $ from 'jquery';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
// import angularUIBootstrap from 'angular-ui-bootstrap';

import { AppComponent } from './app.component.js';
import { components } from './components/components.js';
import { models } from './models/models.js';
// import { messaging } from './messaging.js';
import { config } from './config.js';
import { run } from './config.js';

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for (let registration of registrations) {
            if (registration.scope.includes('firebase-cloud-messaging-push-scope') === false) {
                registration.unregister();
            }
        }
    });
    navigator.serviceWorker
        .register('./firebase-messaging-sw.js', { scope: 'firebase-cloud-messaging-push-scope' })
        .then(function(reg) {
            $('body').bind('update-sw', () => {
                reg.update();
                console.log('Successfully updated service worker', reg);
            });
        })
        .catch(function(err) {
            console.warn('Error whilst registering service worker', err);
        });
}

//Loads the correct sidebar on window load,
//collapses the sidebar on window resize.
// Sets the min-height of #page-wrapper to window size
$(document).ready(function() {
    // Move right sidebar top after scroll
    $(window).scroll(function() {
        if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav')) {
            $('#right-sidebar').addClass('sidebar-top');
        } else {
            $('#right-sidebar').removeClass('sidebar-top');
        }
    });

    // setTimeout(function(){
    //     fix_height();
    // });
});

// // Minimalize menu when screen is less than 768px
// $(function() {
//     $(window).bind('load resize', function() {
//         if ($(document).width() < 769) {
//             $('body').addClass('body-small');
//         } else {
//             $('body').removeClass('body-small');
//         }
//     });
// });

$(document).ready(function() {
    // Set minimal height of #wrapper to fit the window
    setTimeout(function() {
        fixWrapperHeight();
    }, 300);

    // Add special class to minimalize page elements when screen is less than 768px
    setBodySmall();
});

$(window).bind('resize click', function() {
    // Add special class to minimalize page elements when screen is less than 768px
    setBodySmall();

    // Waint until metsiMenu, collapse and other effect finish and set wrapper height
    setTimeout(function() {
        fixWrapperHeight();
    }, 300);
});

function fixWrapperHeight() {
    // Get and set current height
    var headerH = 62;
    var navigationH = $('#navigation').height();
    var contentH = $('.content').height();

    // Set new height when contnet height is less then navigation
    if (contentH < navigationH) {
        $('#wrapper').css('min-height', navigationH + 'px');
    }

    // Set new height when contnet height is less then navigation and navigation is less then window
    if (contentH < navigationH && navigationH < $(window).height()) {
        $('#wrapper').css('min-height', $(window).height() - headerH + 'px');
    }

    // Set new height when contnet is higher then navigation but less then window
    if (contentH > navigationH && contentH < $(window).height()) {
        $('#wrapper').css('min-height', $(window).height() - headerH + 'px');
    }
}

function setBodySmall() {
    if ($(document).width() < 769) {
        $('body').addClass('page-small');
    } else {
        $('body').removeClass('page-small');
        $('body').removeClass('show-sidebar');
    }
}

// console.log(angularUIBootstrap);

const app = angular.module('app', [uiRouter, models.name, components.name, 'messaging']);

app.config(config);
app.run(run);
app.component('app', AppComponent);



// WEBPACK FOOTER //
// ./app/app.js